// src/config/api.ts
// API endpoint configuration

/**
 * API Base URL Strategy:
 * - Development (local): Use empty string to leverage Vite proxy
 * - Production (Azure): Use absolute URL from environment variable
 *
 * When VITE_API_BASE_URL is empty/undefined, relative URLs are used,
 * allowing Vite dev server proxy to forward requests to Azure backend.
 *
 * In production builds, VITE_API_BASE_URL is set via GitHub secrets,
 * resulting in absolute URLs that connect directly to the backend.
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL !== undefined
  ? import.meta.env.VITE_API_BASE_URL
  : 'https://autopilot-api.azurewebsites.net';

const GALLERY_BASE_URL = import.meta.env.VITE_GALLERY_BASE_URL !== undefined
  ? import.meta.env.VITE_GALLERY_BASE_URL
  : '';

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  FORGOT_PASSWORD: `${API_BASE_URL}/auth/password-reset`,
  RESET_PASSWORD: `${API_BASE_URL}/auth/password-reset-confirm`,
  REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh`,

  // OAuth endpoints
  OAUTH_GOOGLE: `${API_BASE_URL}/auth/google`,
  OAUTH_MICROSOFT: `${API_BASE_URL}/auth/microsoft`,
  // Future OAuth providers:
  // OAUTH_GITHUB: `${API_BASE_URL}/auth/github`,
  // OAUTH_APPLE: `${API_BASE_URL}/auth/apple`,
  
  // Account endpoints
  GET_PROFILE: `${API_BASE_URL}/account/profile`,
  UPDATE_PROFILE: `${API_BASE_URL}/account/profile`,
  GET_API_KEYS: `${API_BASE_URL}/auth/apikeys`,
  CREATE_API_KEY: `${API_BASE_URL}/auth/apikey`,
  DELETE_API_KEY: `${API_BASE_URL}/auth/apikey`,
  GET_USAGE: `${API_BASE_URL}/usage/summary`,
  
  // Payment endpoints
  GET_PAYMENT_HISTORY: `${API_BASE_URL}/payment/history`,
  GET_PAYMENT_METHODS: `${API_BASE_URL}/payment/methods`,
  ADD_PAYMENT_METHOD: `${API_BASE_URL}/payment/methods`,
  DELETE_PAYMENT_METHOD: `${API_BASE_URL}/payment/methods`,
  CREATE_PAYMENT_INTENT: `${API_BASE_URL}/payment/create-intent`,
  ESTIMATE_TAX: `${API_BASE_URL}/payment/estimate-tax`,
  GET_SUBSCRIPTION: `${API_BASE_URL}/payment/subscription`,

  // Subscription endpoints
  GET_PLANS: `${API_BASE_URL}/subscription/plans`,
  CREATE_CHECKOUT_SESSION: `${API_BASE_URL}/subscription/checkout`,
  CREATE_PORTAL_SESSION: `${API_BASE_URL}/subscription/portal`,
  GET_SUBSCRIPTION_STATUS: `${API_BASE_URL}/subscription/status`,
  CREATE_PAYG_INTENT: `${API_BASE_URL}/subscription/payg`,

  // Gallery endpoints
  GALLERY_LIST: `${GALLERY_BASE_URL}/gallery`,
  GALLERY_ITEM: (id: string) => `${GALLERY_BASE_URL}/gallery/${id}`,
  GALLERY_CATEGORIES: `${GALLERY_BASE_URL}/gallery/categories`,
  GALLERY_VOTE: (id: string) => `${GALLERY_BASE_URL}/gallery/${id}/vote`,
  GALLERY_REPORT: (id: string) => `${GALLERY_BASE_URL}/gallery/${id}/report`,
  MEDIA_UPLOAD: `${GALLERY_BASE_URL}/media/upload`,

  // Review endpoints
  REVIEWS_APPROVED: `${GALLERY_BASE_URL}/reviews/approved`,
  REVIEWS_STATS: `${GALLERY_BASE_URL}/reviews/stats`,
  REVIEWS_SUBMIT: `${GALLERY_BASE_URL}/reviews`,
  REVIEWS_MINE: `${GALLERY_BASE_URL}/reviews/mine`,
};

export default API_ENDPOINTS;